import React, { useState, useEffect, PureComponent } from "react";
import "../../assets/players.css";
import {
  getRandomNumber,
  sim_player_wording,
} from "../../components/Utils/functions";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import { demoCollegeComps } from "../Utils/demoCollegeComps";
// Tab components
const OverviewTab = ({ data, playerBaseline, similarPlayers }) => {
  const [flippedCards, setFlippedCards] = useState([]);

  const handlePlayerClick = (player, index) => {
    setFlippedCards((prevFlipped) =>
      prevFlipped.includes(index)
        ? prevFlipped.filter((i) => i !== index)
        : [...prevFlipped, index]
    );
  };

  return (
    <div className="overview-tab">
      <div className="overview-tab-top">
        <div className="overview-box">
          <h3>Player Profile</h3>
          <div className="overview-grid">
            <div className="grid-item">Position</div>
            <div className="grid-item">{data.position}</div>
            <div className="grid-item">Age</div>
            <div className="grid-item">{data.age}</div>
            <div className="grid-item">Height</div>
            <div className="grid-item">{data.height}</div>
            <div className="grid-item">Weight</div>
            <div className="grid-item">{data.weight}</div>
            <div className="grid-item">Class</div>
            <div className="grid-item">{data.class}</div>
          </div>
        </div>
        <div className="latest-performance-box">
          <h3>Latest Performance</h3>
          <div className="latest-grid">
            <div className="grid-item">Game</div>
            <div className="grid-item">{data.latest.game}</div>
            <div className="grid-item">Date</div>
            <div className="grid-item">{data.latest.date}</div>
            <div className="grid-item">Minutes</div>
            <div className="grid-item">{data.latest.mins}</div>
            <div className="grid-item">Points</div>
            <div className="grid-item">{data.latest.pts}</div>
            <div className="grid-item">Rebounds</div>
            <div className="grid-item">{data.latest.reb}</div>
            <div className="grid-item">Assists</div>
            <div className="grid-item">{data.latest.ast}</div>
            <div className="grid-item">Steals</div>
            <div className="grid-item">{data.latest.stl}</div>
            <div className="grid-item">Blocks</div>
            <div className="grid-item">{data.latest.blk}</div>
            <div className="grid-item">Turnovers</div>
            <div className="grid-item">{data.latest.to}</div>
            <div className="grid-item">Personal Fouls</div>
            <div className="grid-item">{data.latest.pf}</div>
            <div className="grid-item">Field Goals</div>
            <div className="grid-item">{data.latest.fg}</div>
          </div>
        </div>
      </div>
      <div className="sim-player-container">
        <div className="sim-player-header">
          <img
            className="sim-player-header-image"
            src={playerBaseline?.image_url || ""}
            alt={playerBaseline?.name}
          />
          <h3>{playerBaseline?.player_name} College Comparison </h3>
        </div>
        <div className="sim-player-grid">
          {(demoCollegeComps[playerBaseline?.player_id] || similarPlayers).map(
            (player, index) => (
              <div
                className={`sim-player-card ${
                  flippedCards.includes(index) ? "flipped" : ""
                }`}
                key={index}
                onClick={() => handlePlayerClick(player, index)}
              >
                <div className="sim-player-inner">
                  <div className="sim-player-front">
                    <div className="sim-player-image-wrapper">
                      <img src={player.image} alt={player.name} />
                    </div>
                    <div className="sim-player-info">
                      <h4>{player.name}</h4>
                      <p className="sim-player-position">{player.position}</p>
                      <p className="sim-player-school">{player.school}</p>
                      <div className="sim-player-stats">
                        <div className="sim-player-stat-item">
                          <span className="sim-player-stat-label">
                            Ball Handling:
                          </span>
                          <span
                            className="sim-player-stat-value"
                            style={{
                              color: sim_player_wording(player.ball_handling)
                                .color,
                            }}
                          >
                            {sim_player_wording(player.ball_handling).wording}
                          </span>
                        </div>
                        <div className="sim-player-stat-item">
                          <span className="sim-player-stat-label">
                            Scoring:
                          </span>
                          <span
                            className="sim-player-stat-value"
                            style={{
                              color: sim_player_wording(player.scoring).color,
                            }}
                          >
                            {sim_player_wording(player.scoring).wording}
                          </span>
                        </div>
                        <div className="sim-player-stat-item">
                          <span className="sim-player-stat-label">
                            Rebounding:
                          </span>
                          <span
                            className="sim-player-stat-value"
                            style={{
                              color: sim_player_wording(player.rebounding)
                                .color,
                            }}
                          >
                            {sim_player_wording(player.rebounding).wording}
                          </span>
                        </div>
                        <div className="sim-player-stat-item">
                          <span className="sim-player-stat-label">
                            Defense:
                          </span>
                          <span
                            className="sim-player-stat-value"
                            style={{
                              color: sim_player_wording(player.defense).color,
                            }}
                          >
                            {sim_player_wording(player.defense).wording}
                          </span>
                        </div>
                        <div className="sim-player-stat-item">
                          <span className="sim-player-stat-label">
                            Playmaking:
                          </span>
                          <span
                            className="sim-player-stat-value"
                            style={{
                              color: sim_player_wording(player.playmaking)
                                .color,
                            }}
                          >
                            {sim_player_wording(player.playmaking).wording}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="sim-player-back">
                    <h4>{player.name}</h4>
                    <p style={{ textAlign: "left" }}>{player.content}</p>
                  </div>
                </div>
              </div>
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default OverviewTab;
